module.exports = __webpack_public_path__ + "static/media/pic_rep_2.8f96eac1.jpg";